<template>
  <div v-if="hasAccess">
    <PageHeader
      title="Gestion équipe CM"
      description="Gestion des community managers"
      :button="{
        icon: 'fas fa-plus-circle',
        text: 'Ajouter un community manager',
        action: openCreateModal
      }"
    />

    <PageContent>
      <MVPTable
        :grid-data="communityManagers"
        :options="gridOptions"
        statusBarType="displayed"
        @gridReady="onGridReady"
        @rowDoubleClicked="openEditModal"
      />
    </PageContent>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { http } from '@/services/api.service'
import PageHeader from '@/components/PageHeader.vue'
import PageContent from '@/components/PageContent.vue'
import MVPTable from '@/components/agGrid/MVPTable.vue'
import InternalTeamCommunityManagerForm from './InternalTeamCommunityManagerForm.vue'

export default {
  name: 'app-dashboard-internal-team-management',
  components: {
    PageHeader,
    PageContent,
    MVPTable
  },
  data () {
    return {
      loading: false,
      communityManagers: [],
      gridApi: null,
      gridOptions: {
        rowModelType: 'clientSide',
        suppressContextMenu: true,
        defaultColDef: {
          sortable: true,
          filter: 'agTextColumnFilter',
          resizable: true
        },
        columnDefs: [
          {
            headerName: 'Nom',
            field: 'lastname',
            sort: 'asc'
          },
          {
            headerName: 'Prénom',
            field: 'firstname'
          },
          {
            headerName: 'Adresse e-mail',
            field: 'email'
          },
          {
            headerName: '',
            field: 'edit',
            width: 72,
            suppressMenu: true,
            sortable: false,
            filter: false,
            cellRenderer: 'IconCellRenderer',
            cellRendererParams: {
              iconClass: 'fas fa-pen text-blue-600',
              onClick: manager => this.openEditModal({ data: manager })
            }
          },
          {
            headerName: '',
            field: 'delete',
            width: 72,
            suppressMenu: true,
            sortable: false,
            filter: false,
            cellRenderer: 'IconCellRenderer',
            cellRendererParams: {
              iconClass: 'fas fa-trash text-red-600',
              onClick: manager => this.confirmDelete(manager)
            }
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['roles']),
    hasAccess () {
      return this.roles.some(role => ['admin', 'community-manager'].includes(role))
    }
  },
  async created () {
    if (!Array.isArray(this.roles) || this.roles.length === 0) {
      await this.$store.dispatch('FETCH_ROLES')
    }

    if (!this.hasAccess) {
      this.$router.replace('/app/dashboard')
      return
    }

    this.loadCommunityManagers()
  },
  methods: {
    onGridReady (params) {
      this.gridApi = params.api
    },
    async loadCommunityManagers () {
      this.loading = true

      try {
        const { data } = await http.get('/community-manager')
        this.communityManagers = Array.isArray(data) ? data : []
      } catch (err) {
        console.log(err)
        this.$notify({
          group: 'maviepro-error',
          text: 'Impossible de charger les community managers.'
        })
      } finally {
        this.loading = false
      }
    },
    openCreateModal () {
      this.openFormModal(null)
    },
    openEditModal ({ data }) {
      if (!data || !data.uuid) {
        return
      }

      this.openFormModal(data)
    },
    openFormModal (manager) {
      this.$buefy.modal.open({
        parent: this,
        component: InternalTeamCommunityManagerForm,
        hasModalCard: true,
        trapFocus: true,
        props: {
          manager
        },
        events: {
          saved: () => {
            this.$notify({
              group: 'maviepro-success',
              text: 'Community manager enregistré.'
            })
            this.loadCommunityManagers()
          }
        }
      })
    },
    confirmDelete (manager) {
      if (!manager || !manager.uuid) {
        return
      }

      const identifier = manager.email || `${manager.firstname || ''} ${manager.lastname || ''}`.trim() || 'ce community manager'

      this.$dialog.confirm({
        title: 'Supprimer ce community manager ?',
        text: `Le compte ${identifier} sera retiré de l'équipe interne.`,
        icon: 'warning',
        cancelButtonText: 'Annuler',
        okButtonText: 'Supprimer'
      }).then(async result => {
        if (!result.isOk || result.hideReason !== 'ok') {
          return
        }

        try {
          await http.delete(`/community-manager/${manager.uuid}`)
          this.$notify({
            group: 'maviepro-success',
            text: 'Community manager supprimé.'
          })
          this.loadCommunityManagers()
        } catch (err) {
          const message = err?.response?.data?.message || 'Erreur lors de la suppression du community manager.'
          this.$notify({
            group: 'maviepro-error',
            text: message
          })
        }
      })
    }
  }
}
</script>
